import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldValidatorFn } from "@ngx-formly/core/lib/models";
// import { ValidatorOption } from "@ngx-formly/core/lib/services/formly.config";
import { Observable } from "rxjs";
import { Logger } from "src/app/core/logger";
import { environment } from "src/environments/environment";
import "systemjs";
export interface ValidatorOption {
  name: string;
  validation: FieldValidatorFn;
  options?: {
      [id: string]: any;
  };
}
@Injectable({
  providedIn: 'root'
})
export class FormlyValidationService {
  constructor(private httpClient: HttpClient,
    private logger: Logger) {
  }

  getFormConfig(): Observable<FormlyFieldConfig[]> {
    return this.httpClient.get(environment.endpoints.form) as Observable<FormlyFieldConfig[]>;
  }

  getValidators(): Observable<[ValidatorOption]> {
    return new Observable<[ValidatorOption]>(subscriber => {
      System.import(environment.endpoints.validatorsUrl)
        .then((module: any) => {
          subscriber.next(module.validators as [ValidatorOption]);
          subscriber.complete();
        })
        .catch((err) => {
          this.logger.warn("getValidators "+err);
        });
    });
  }
}
